import {
  UPDATE_CORPORATE_STATUS,
  UPDATE_CORPORATE_STATUS_SUCCESS,
  UPDATE_CORPORATE_STATUS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  updateStatus: null,
};

const updateCorporateStatusReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_CORPORATE_STATUS:
      return { ...state, loading: true };
    case UPDATE_CORPORATE_STATUS_SUCCESS:
      return {
        ...state,
        updateStatus: action?.payload,
        loading: false,
      };
    case UPDATE_CORPORATE_STATUS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default updateCorporateStatusReducer;